module.exports = __webpack_public_path__ + "static/media/achievement-pen-pal.344d1735.svg";